import { useCallback } from 'react';

import { Actions } from '../../constants/actionTypes';
import type { TCannedResponse } from '../../interfaces/TChat';
import { useMainDispatch } from '../useMainDispatch';
import { useMainSelector } from '../useMainSelector';

export const useCannedResponses = () => {
  const {
    chat: { cannedResponses, isCannedResponsesMenuOpen },
    settings: { selectedCannedResponse },
  } = useMainSelector();

  const dispatch = useMainDispatch();

  const setSelectedCannedResponse = useCallback(
    (cannedResponse: TCannedResponse) => {
      dispatch({
        type: Actions.SET_SETTINGS,
        payload: { selectedCannedResponse: cannedResponse },
      });
    },
    [dispatch],
  );

  return {
    cannedResponses: cannedResponses?.filter(
      (cannedResponse) =>
        cannedResponse.identifier &&
        cannedResponse.message &&
        cannedResponse.shorthand,
    ),
    setSelectedCannedResponse,
    selectedCannedResponse,
    isCannedResponsesMenuOpen,
  };
};
